<header>
	<mat-form-field class="col-2" title="CNPJ da matriz" appearance="outline">
		<mat-label>Organização</mat-label>
		<mat-select
			[formControl]="filter"
			(selectionChange)="onFilterChange($event.value)"
		>
			<mat-option *ngFor="let org of orgs" [value]="org.id">
				{{ org.name }}
			</mat-option>
		</mat-select>
	</mat-form-field>
	<button mat-flat-button color="primary" routerLink="cadastro">
		<mat-icon>add</mat-icon>
		<span class="no-mob">Novo Link</span>
	</button>
</header>
<div class="d-f jc-c ai-c mt-sm w-100 loader" *ngIf="loading$ | async">
	<mat-spinner diameter="20"></mat-spinner>
</div>
<ng-container *ngIf="(loading$ | async) === false">
	<div
		class="pos-r mb-xxxs pb-nano br-md c-p card"
		(click)="onEditLink(link)"
		*ngFor="let link of filteredLinks"
	>
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f jc-sb ai-c mb-xxxs card-top">
				<div class="d-f fd-c jc-c col">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Empresa</span>
					<span class="mt-quark fs-xxs lh-md to-ellipsis">
						{{ link.organization_name }}
					</span>
				</div>
				<div class="d-f fd-c jc-c col">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Tipo</span>
					<span class="mt-quark fs-xxs lh-md to-ellipsis">
						{{ processChartType(link.name) }}
					</span>
				</div>
			</div>
			<div class="d-f ai-c card-bottom">
				<div class="d-f fd-c jc-c w-100">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Link</span>
					<span class="mt-quark fs-xxs lh-md to-ellipsis">{{ link.link }}</span>
				</div>
			</div>
		</div>
	</div>
</ng-container>
<div class="mb-huge"></div>
